import { useMemo } from 'react'
import { PendingScheduleType } from '../common/types/calendar'

const useFilterSchedules = (schedules: PendingScheduleType[], searchText: string) => {
  const filtered = useMemo(() => {
    return schedules.filter((schedule) => {
      const name = schedule.name;
      return name && name.includes(searchText.trim())
    })
  }, [schedules, searchText])
  return filtered
}

export default useFilterSchedules
